export default __webpack_public_path__ + "static/media/login_new.c76688d7.svg";